export default __webpack_public_path__ + "static/media/htc@2x.8569dc01.jpg";